import { Vue, Component, Prop } from 'vue-property-decorator';
import { CustomerDocumentListItemDTO } from '@/../client-generator/generated-clients/customer-documents';

@Component
export default class DocumentListItem extends Vue {
  @Prop({ default: null }) document!: CustomerDocumentListItemDTO;
  @Prop({ default: false }) simpleView!: boolean;

  get creationDate() {
    const theDate = new Date(this.document.creationDate as Date);
    return theDate.toLocaleDateString(undefined, {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
    });
  }

  get isNew() {
    return this.document.downloadCount === 0;
  }

  async handleDownload() {
    this.$emit('handle-download');
  }
}
